import {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useForm} from "react-hook-form";
import * as yup from "yup";
import {yupResolver} from "@hookform/resolvers/yup";
import {uploadFile} from "store/actions/asset";
import {ACTION_TYPE, SSAFY9_ORGANIZATION, enumCompetitionType} from "utils/constants";
// import {ImageCompressor} from "utils//FileCompressor";
import View from "./View.js";
import {getWorld} from "api-v3";
import {changePublishMode} from "store/actions/mode.js";
// import uuid4 from "uuid4";

function Container({dismiss}) {
  const dispatch = useDispatch();
  const {group} = useSelector(state => state.userinfo);
  const [isWorldExist, setIsWorldExist] = useState(false);
  const [searchData, setSearchData] = useState("");
  const [contest, setContest] = useState("None");

  const getSchema = contest =>
    yup.object().shape({
      name: yup.string().required("콘텐츠 이름을 입력해 주세요."),
      description: yup.string().required("콘텐츠 설명을 입력해 주세요."),
      phoneNumber: yup.string(),
      thumbnail: yup.mixed().test("fileSize", "Thumbnail capacity size(3MB) limit exceeded.", value => {
        if (value?.length === 0 || value === undefined) return true;
        return value?.[0]?.size < 3 * 1000 * 1000;
      }),
    });

  const publishForm = useForm({
    mode: "onBlur",
    defaultValues: {name: "", description: "", phoneNumber: "", thumbnail: undefined},
    resolver: yupResolver(getSchema(contest)),
  });
  const {watch, reset} = publishForm;

  // State
  const [isClickUpload, setIsClickUpload] = useState(false);
  const [thumbPreview, setThumbPreview] = useState("");
  const [selectedOrganization, setSelectedOrganization] = useState(SSAFY9_ORGANIZATION[0]);

  const _progress = useSelector(state => state.progress.progress);

  const thumbnail = watch("thumbnail");
  useEffect(() => {
    if (thumbnail && thumbnail.length > 0) {
      makeImagePreview(thumbnail[0]);
    }
  }, [thumbnail]);

  const makeImagePreview = fileBlob => {
    const reader = new FileReader();
    reader.readAsDataURL(fileBlob);
    return new Promise(resolve => {
      reader.onload = () => {
        setThumbPreview(reader.result);
        resolve();
      };
    });
  };

  const onClickUpload = () => {
    setIsClickUpload(!isClickUpload);
  };

  const getDate = () => new Date().toISOString().split("T")[0];

  const submitUpload = async data => {
    data.agreementDate = getDate();
    let thumbnail = null;
    if (data.thumbnail.length > 0) {
      thumbnail = data.thumbnail[0];
    }
    onClickUpload();
    data.competitionType = enumCompetitionType[contest];
    if (group) {
      data.group = group;
      data.class = selectedOrganization;
    }

    const action = createAction({
      category: "file",
      ...data,
      thumbnail: thumbnail,
      isWorldExist,
    });
    dispatch(uploadFile(action));
  };

  const createAction = publishInfo => {
    return {
      command: ACTION_TYPE.UPLOAD_FILE,
      ...publishInfo,
    };
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const pId = searchParams.get("pid");
    checkWorldExist(pId).then(data => {
      if (data?.id) {
        setIsWorldExist(true);
        reset({
          name: data.name,
          description: data.description,
          phoneNumber: data.phoneNumber,
          icon: data.icon,
        });
        setThumbPreview(data.icon);
      }
    });
  }, []);

  const checkWorldExist = async id => {
    const res = await getWorld({id});

    return res.data;
  };

  const [isShowJoinToggle, setIsShowJoinToggle] = useState(false);

  const onClickJoinToggle = () => {
    setIsShowJoinToggle(!isShowJoinToggle);
  };

  const onClickOrganization = organization => {
    setSelectedOrganization(organization);
    setIsShowJoinToggle(false);
    setSearchData("");
  };

  const onClickPublishMode = mode => {
    dispatch(changePublishMode(mode));
  };

  const onClickContests = e => {
    setContest(e);
  };

  return (
    <View
      publishForm={publishForm}
      progress={_progress}
      isClickUpload={isClickUpload}
      dismiss={dismiss}
      submitUpload={submitUpload}
      thumbPreview={thumbPreview}
      onClickUpload={onClickUpload}
      isShowJoinToggle={isShowJoinToggle}
      onClickJoinToggle={onClickJoinToggle}
      selectedOrganization={selectedOrganization}
      onClickOrganization={onClickOrganization}
      onClickPublishMode={onClickPublishMode}
      group={group}
      searchData={searchData}
      setSearchData={setSearchData}
      onClickContests={onClickContests}
      contest={contest}
    />
  );
}

export default Container;
